module.exports = __webpack_public_path__ + "img/icons_11052020.svg";